/* ZYVERA - PDP enhancements.

   PRESENTATION-ONLY. This file does NOT reimplement gallery slide logic,
   variant sync, cart or checkout - all of that lives in assets/zy-product.js,
   which is commerce-critical and locked. Where this file needs the gallery to
   change slide it CLICKS THE EXISTING [data-zy-gallery-prev] /
   [data-zy-gallery-next] buttons, so the locked file stays the single owner
   of slide state and slide order.

   Four jobs:
     1. Keep the media picker's accessibility state honest.
     2. Touch swipe on the stage, and tap-to-enlarge.
     3. The enlarge / detail-inspection viewer (native <dialog>).
     4. Reveal related products only once cards actually exist.
*/
(function () {
  var gallery = document.querySelector('[data-zy-gallery]');
  var stage   = document.querySelector('[data-zy-gallery-stage]');
  var prev    = document.querySelector('[data-zy-gallery-prev]');
  var next    = document.querySelector('[data-zy-gallery-next]');
  var zoomBtn = document.querySelector('[data-zy-gallery-zoom]');
  var dialog  = document.querySelector('[data-zy-lightbox]');

  function activeSlide() {
    return stage ? stage.querySelector('[data-zy-slide]:not([hidden])') : null;
  }

  /* --------------------------------------------------------------- *
   * 1. MEDIA PICKER ACCESSIBILITY STATE
   *
   * The locked zy-product.js maintains two things per thumbnail: the
   * .zy-gallery__thumb--active class, and aria-selected. aria-selected was
   * correct under the retired role=tab model; the thumbnails are now native
   * buttons, where aria-selected is not a permitted attribute. Rather than
   * edit the locked file, we mirror its class into the attribute that IS
   * correct for a button in a set - aria-current - and strip the stray one.
   *
   * The observer filters on 'class' and 'hidden' only. We only ever write
   * aria-* attributes, so our own writes can never retrigger it.
   * --------------------------------------------------------------- */
  function syncThumbs() {
    if (!gallery) return;
    var thumbs = gallery.querySelectorAll('[data-zy-thumb]');
    for (var i = 0; i < thumbs.length; i++) {
      var t = thumbs[i];
      t.removeAttribute('aria-selected');
      if (t.classList.contains('zy-gallery__thumb--active')) {
        t.setAttribute('aria-current', 'true');
      } else {
        t.removeAttribute('aria-current');
      }
    }
  }

  /* --------------------------------------------------------------- *
   * 2/3. ENLARGE VIEWER
   *
   * No high-resolution byte is fetched until the customer asks for one: the
   * dialog's <img> ships with no src at all and is populated on open.
   *
   * The affordance only appears for slides marked data-zy-zoomable="true",
   * which Liquid sets only when the source is at least 1200px wide. A small
   * image never offers an enlarge that would just show blur.
   * --------------------------------------------------------------- */
  var lbImg     = dialog && dialog.querySelector('[data-zy-lightbox-img]');
  var lbClose   = dialog && dialog.querySelector('[data-zy-lightbox-close]');
  var lbPrev    = dialog && dialog.querySelector('[data-zy-lightbox-prev]');
  var lbNext    = dialog && dialog.querySelector('[data-zy-lightbox-next]');
  var lbCounter = dialog && dialog.querySelector('[data-zy-lightbox-counter]');
  var lastFocused = null;
  var scrollLocked = false;

  function slideIsZoomable(s) {
    return !!(s && s.getAttribute('data-zy-zoomable') === 'true' && s.getAttribute('data-zy-full'));
  }

  function syncZoomAffordance() {
    if (!zoomBtn) return;
    zoomBtn.hidden = !slideIsZoomable(activeSlide());
  }

  function paintLightbox() {
    var s = activeSlide();
    if (!dialog || !lbImg || !slideIsZoomable(s)) return false;
    lbImg.removeAttribute('src');
    lbImg.removeAttribute('srcset');
    lbImg.setAttribute('width', s.getAttribute('data-zy-full-w') || '');
    lbImg.setAttribute('height', s.getAttribute('data-zy-full-h') || '');
    lbImg.alt = s.getAttribute('data-zy-full-alt') || '';
    lbImg.setAttribute('sizes', '92vw');
    lbImg.setAttribute('srcset', s.getAttribute('data-zy-full-srcset') || '');
    lbImg.setAttribute('src', s.getAttribute('data-zy-full'));
    if (lbCounter) {
      var all = stage.querySelectorAll('[data-zy-slide]');
      lbCounter.textContent = (s.getAttribute('data-zy-index') || '1') + ' / ' + all.length;
    }
    return true;
  }

  function lockScroll() {
    if (scrollLocked) return;
    /* overflow on the root element, NOT position:fixed on body - fixed
       positioning discards the scroll offset and the page jumps to the top
       when the viewer closes. */
    document.documentElement.style.overflow = 'hidden';
    scrollLocked = true;
  }
  function unlockScroll() {
    if (!scrollLocked) return;
    document.documentElement.style.overflow = '';
    scrollLocked = false;
  }

  function openLightbox() {
    if (!dialog || typeof dialog.showModal !== 'function') return;
    if (dialog.open) return;
    if (!paintLightbox()) return;
    lastFocused = document.activeElement;
    dialog.showModal();
    lockScroll();
    if (lbClose) lbClose.focus();
  }

  function closeLightbox() {
    if (dialog && dialog.open) dialog.close();
  }

  if (dialog) {
    /* Native <dialog> gives us the focus trap, Escape, and inertness of the
       page behind it. We only add what the platform does not: scroll lock,
       backdrop-click, and explicit focus return. */
    dialog.addEventListener('close', function () {
      unlockScroll();
      /* Browsers restore focus themselves, but only if the opener is still
         in the document and focusable. Guard the case where it is not. */
      if (lastFocused && document.contains(lastFocused) &&
          document.activeElement === document.body) {
        try { lastFocused.focus(); } catch (e) {}
      }
      lastFocused = null;
    });

    dialog.addEventListener('click', function (e) {
      /* A click whose target IS the dialog element is a backdrop click. */
      if (e.target === dialog) closeLightbox();
    });

    dialog.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft' && lbPrev) { e.preventDefault(); lbPrev.click(); }
      if (e.key === 'ArrowRight' && lbNext) { e.preventDefault(); lbNext.click(); }
    });

    if (lbClose) lbClose.addEventListener('click', closeLightbox);

    /* The viewer never decides which image comes next. It clicks the page's
       own nav, lets the locked file move the gallery, then repaints itself
       from whichever slide is now active. */
    if (lbPrev && prev) lbPrev.addEventListener('click', function () { prev.click(); paintLightbox(); });
    if (lbNext && next) lbNext.addEventListener('click', function () { next.click(); paintLightbox(); });
  }

  if (zoomBtn) zoomBtn.addEventListener('click', openLightbox);

  /* --------------------------------------------------------------- *
   * 2. SWIPE + TAP
   * Horizontal intent only. Vertical page scrolling is never blocked or
   * hijacked - gestures that are mostly vertical are simply ignored. A
   * gesture that moved is a swipe and must NOT also register as a tap.
   * --------------------------------------------------------------- */
  if (stage) {
    var startX = 0, startY = 0, tracking = false, swiped = false;
    var THRESHOLD = 45;   // px of horizontal travel before it counts
    var SLOP = 1.2;       // horizontal must beat vertical by this factor

    stage.addEventListener('touchstart', function (e) {
      swiped = false;
      if (e.touches.length !== 1) { tracking = false; return; }
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      tracking = true;
    }, { passive: true });

    stage.addEventListener('touchend', function (e) {
      if (!tracking) return;
      tracking = false;
      var t = e.changedTouches && e.changedTouches[0];
      if (!t) return;
      var dx = t.clientX - startX;
      var dy = t.clientY - startY;
      if (Math.abs(dx) > 10 || Math.abs(dy) > 10) swiped = true;
      if (!prev || !next) return;
      if (Math.abs(dx) < THRESHOLD) return;
      if (Math.abs(dx) < Math.abs(dy) * SLOP) return; // vertical scroll intent
      (dx < 0 ? next : prev).click();
    }, { passive: true });

    /* Click-the-picture is a convenience on top of the real button, never
       the only way in. Ignore clicks on the overlay controls, clicks that
       were really the end of a swipe, and any text selection drag. */
    stage.addEventListener('click', function (e) {
      if (swiped) { swiped = false; return; }
      if (e.target.closest('button')) return;
      var sel = window.getSelection && window.getSelection();
      if (sel && String(sel).length > 0) return;
      if (!slideIsZoomable(activeSlide())) return;
      openLightbox();
    });
  }

  /* --------------------------------------------------------------- *
   * Watch the gallery for slide changes made by the locked file, and keep
   * the picker state, the zoom affordance and an open viewer in step.
   * --------------------------------------------------------------- */
  if (gallery && 'MutationObserver' in window) {
    var gmo = new MutationObserver(function () {
      syncThumbs();
      syncZoomAffordance();
      if (dialog && dialog.open) paintLightbox();
    });
    gmo.observe(gallery, {
      attributes: true,
      subtree: true,
      attributeFilter: ['hidden', 'class']
    });
  }
  syncThumbs();
  syncZoomAffordance();

  /* --------------------------------------------------------------- *
   * 4. RELATED PRODUCTS - reveal only when populated.
   * The block ships with [hidden] so an empty feed shows nothing at all (no
   * bare "You may also like"). zy-product.js fetches and appends the cards;
   * we watch for them and unhide. If nothing arrives, it stays hidden.
   * --------------------------------------------------------------- */
  var relatedRoot = document.querySelector('[data-zy-related]');
  var relatedGrid = document.querySelector('[data-zy-related-grid]');

  if (relatedRoot && relatedGrid && 'MutationObserver' in window) {
    if (relatedGrid.children.length > 0) {
      relatedRoot.hidden = false;
    } else {
      var mo = new MutationObserver(function () {
        if (relatedGrid.children.length > 0) {
          relatedRoot.hidden = false;
          mo.disconnect();
        }
      });
      mo.observe(relatedGrid, { childList: true });
      window.setTimeout(function () { mo.disconnect(); }, 10000);
    }
  }
})();
